import React from 'react'
// import PropTypes from 'prop-types'

import { MainTitle, TextContent, HighlightText, ItemListText } from '../../../Shared';

const MakingRequests = props => {
  return (
    <div>
      <MainTitle>Making Requests</MainTitle>
      <TextContent>
      As per RESTful design patterns, BK Traffic API implements following HTTP verbs:
      </TextContent>
      <ul>
        <ItemListText> GET - Read resources </ItemListText>
        <ItemListText> POST - Create or update resources </ItemListText>
      </ul>
      <TextContent>
      When making requests, arguments can be passed as params, form data or JSON with correct <HighlightText> Content-Type </HighlightText> header.
      </TextContent>
      <TextContent><b>API endpoint: </b> <HighlightText>https://api.bktraffic.com</HighlightText> </TextContent>
    </div>
  )
}

MakingRequests.propTypes = {

}

export default MakingRequests
